import ToggleButton from "../toggle-button";
import style from "./orgchart-item-view-type.module.css";
import { OrgChartViewType } from "shared/datamodel/schemas/org-chart";

const fullViewIcon = (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.2 4L17 4L17 19L1 19L1 4L5.8 4" stroke="white" strokeWidth="1.5" />
    <circle cx="9.04027" cy="4.33422" r="2.79027" stroke="white" strokeWidth="1.5" />
    <line x1="5" y1="10.25" x2="13" y2="10.25" stroke="white" strokeWidth="1.5" />
    <line x1="6" y1="13.25" x2="12" y2="13.25" stroke="white" strokeWidth="1.5" />
  </svg>
);

const noPictureViewIcon = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="17" y="1" width="16" height="16" transform="rotate(90 17 1)" stroke="white" strokeWidth="1.5" />
    <line x1="3.5957" y1="5.44238" x2="13.9805" y2="5.44238" stroke="white" strokeWidth="1.5" />
    <path d="M4.46094 8.78857H12.9576" stroke="white" strokeWidth="1.5" />
    <path d="M6.19141 12H11.3838" stroke="white" strokeWidth="1.5" />
  </svg>
);

export default function OrgChartItemViewType({
  value,
  onChange,
}: {
  value: OrgChartViewType;
  onChange: (viewtype: OrgChartViewType) => void;
}) {
  return (
    <div className={style.container} data-testid="OrgchartItemViewType">
      <ToggleButton
        isOn={value === OrgChartViewType.Default}
        onClick={() => onChange(OrgChartViewType.Default)}
        tooltip={"Show image"}
      >
        {fullViewIcon}
      </ToggleButton>
      <ToggleButton
        isOn={value === OrgChartViewType.NoProfilePicture}
        onClick={() => onChange(OrgChartViewType.NoProfilePicture)}
        tooltip={"Hide image"}
      >
        {noPictureViewIcon}
      </ToggleButton>
    </div>
  );
}
